export const TARGETING = 'targeting';
export const PARTNER = 'partner';
export const TYPE = 'type';
export const ENTRIES = 'entries';

export const TYPE_CAMPAIGN_BASED = 'campaignBased';
export const TYPE_PARTNER_AUDIENCE_BASED = 'partnerAudienceBased';
export const PARTNER_AUDIENCE = 'partnerAudience';

export const COUNTRIES = 'countries';

export const NAME = 'name';
export const ACCOUNT = 'account';
export const CAMPAIGNS = 'campaigns';

export const ADSETS = 'adSets';
export const CREDENTIALS = 'credentials';
